import { transparentize } from 'polished'
import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'

export const StandardContentHeader = styled.div`
  border-bottom: 0.1rem solid ${transparentize(0.5, colors.midGrey)};
`
